import { useRef, useState } from "react";
import QuillEditor from "./QuillEditor";

function ReactQuillEditor({ defaultValue, onTextChange }) {
  const [range, setRange] = useState();
  const [lastChange, setLastChange] = useState();
  const [readOnly, setReadOnly] = useState(false);
  const quillRef = useRef();
  return (
    <>
      <QuillEditor
        ref={quillRef}
        readOnly={false}
        defaultValue={defaultValue}
        onSelectionChange={setRange}
        onTextChange={setLastChange}
        onChange={onTextChange}
      />
    </>
  );
}

export default ReactQuillEditor;
